import app from 'flarum/app';

/* global m */

export default class Uploader {
    constructor(form) {
        this.form = form;
        this.uploading = false;
    }

    upload(files, key) {
        const data = new FormData();

        for (let i = 0; i < files.length; i++) {
            data.append(key + '[]', files[i]);
        }

        this.uploading = true;
        m.redraw();

        return new Promise((resolve, reject) => {
            app.request({
                method: 'POST',
                url: app.forum.attribute('apiUrl') + this.form.apiEndpoint() + '/upload',
                serialize: raw => raw,
                data,
            }).then(result => {
                this.uploading = false;
                m.redraw();

                resolve(app.store.pushPayload(result));
            }).catch(err => {
                this.uploading = false;
                m.redraw();

                reject(err);
            });
        });
    }
}
